<template>
  <Transition name="fade" appear>
    <div
      class="modal fade show"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      style="display: block; background-color: rgba(0, 0, 0, 0.3); z-index: 12000"
    >
      <div
        class="spinner-border text-primary"
        style="
          display: block;
          position: fixed;
          top: calc(50% - (32px / 2));
          right: calc(50% - (32px / 2));
        "
      />
      <div 
        style="
          display: block;
          position: fixed;
          top: calc(50% + 25px);
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          color: #ffffff;
          text-align: center;
      " v-html="formattedLoadingText"></div>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  loadingText: {
    type: String,
    default: ''
  }
})

const formattedLoadingText = computed(() => {
  return props.loadingText.replace(/\n/g, '<br>')
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
